export const PRODUCT_TYPES = [
  { code: 'GANESH_POOJA_BOX', displayName: 'Ganesh Pooja Gift Box' },
  { code: 'LAKSHMI_FESTIVE_BOX', displayName: 'Lakshmi Festive Gift Box' },
  { code: 'CUSTOM_GIFT_BOX', displayName: 'Custom FOIS Gift Box' },
  { code: 'INDIVIDUAL_PRODUCT', displayName: 'Individual FOIS Product' },
] as const;

export type ProductTypeCode = (typeof PRODUCT_TYPES)[number]['code'];

export const PRODUCT_TYPE_CODES = PRODUCT_TYPES.map((item) => item.code) as [
  ProductTypeCode,
  ...ProductTypeCode[],
];

export function displayNameForProductType(code: string): string | undefined {
  return PRODUCT_TYPES.find((item) => item.code === code)?.displayName;
}

export function isProductTypeCode(value: string): value is ProductTypeCode {
  return PRODUCT_TYPES.some((item) => item.code === value);
}
